import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DoubleChevronRightIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("polyline", {
    points: "11.81 17.99 17.85 11.99 11.86 6.01",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "6.15 17.99 12.19 11.99 6.2 6.01",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })]
}), 'DoubleChevronRightIcon');